import * as React from 'react';

const Umbrella16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M10.962 6.92s3.234-3.243 3.32-3.32a7.57 7.57 0 0 0-5.395-2.24c-1.96 0-3.89.743-5.377 2.23a7.603 7.603 0 0 0 .02 10.772l3.33-3.32 1.544-1.545 4.681 4.682 1.024-1.023-4.682-4.682 1.535-1.535V6.92ZM4.659 4.748c.53-.53 2.461-.029 4.585 1.844L6.502 9.333C4.562 7.142 4.137 5.27 4.66 4.748Zm7.461-1.033c-.434.435-1.033 1.033-1.843 1.854C8.973 4.4 7.64 3.629 6.482 3.29a6.15 6.15 0 0 1 2.404-.493 6.11 6.11 0 0 1 3.233.917ZM2.728 8.957c0-.83.164-1.632.473-2.384.328 1.158 1.11 2.47 2.268 3.784L3.645 12.18a6.052 6.052 0 0 1-.917-3.224Z"
  }
));
Umbrella16.Size = 16;
Umbrella16.Title = "Umbrella";

export { Umbrella16 as default };
